import * as configuration from '@/infrastructure/Configuration'
import { DateFactory } from 'rhg-vue-common'
import SearchTypes from '@/domain/SearchTypes'
import ExternalStorage from '@/services/ExternalStorage'

const SourceOfBusiness = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop'
}

class BookingService {
  constructor (httpClient, device) {
    this.httpClient = httpClient
    this.device = device
  }

  async preBooking (availabilityRequest, rate, rewardsNumber) {
    const transactionId = ExternalStorage.session.transactionId()
    const config = {
      headers: {
        transactionId
      }
    }

    !transactionId && delete config.headers.transactionId

    const taxIncludedRegion = ExternalStorage.cookies.taxIncludedRegion()
    const taxExcludedRegion = ExternalStorage.cookies.taxExcludedRegion()
    const preBookingRequest = this._mapPreBookingRequest(availabilityRequest, rate, rewardsNumber, taxIncludedRegion, taxExcludedRegion)
    const response = await this.httpClient.post(configuration.apiInitiate, preBookingRequest, config)
    return response.data
  }

  isTaxIncludeRegion = (included, excluded) => {
    let tax
    if (included) {
      tax = true
    }
    if (excluded) {
      tax = false
    }
    return tax
  }

  _mapPreBookingRequest (availabilityRequest, rate, rewardsNumber, taxIncludedRegion, taxExcludedRegion) {
    const request = {
      searchType: availabilityRequest.searchType,
      promotionCode: mapPromotionCode(availabilityRequest),
      checkInDate: DateFactory.formatDate(DateFactory.dateObject(availabilityRequest.checkInDate)),
      checkOutDate: DateFactory.formatDate(DateFactory.dateObject(availabilityRequest.checkOutDate)),
      hotelCode: availabilityRequest.hotelCode,
      occupancies: availabilityRequest.occupancies,
      rateId: rate.id,
      rates: mapRates(rate, availabilityRequest),
      roomCode: rate.roomId,
      facilitatorId: availabilityRequest.facilitatorId,
      merchantId: availabilityRequest.merchantId,
      rezidorProperty: availabilityRequest.rezidorProperty,
      isWebView: !!global.UtilsUrl && global.UtilsUrl.getURLParameter('app') === 'true',
      sourceOfBusiness: this.device.desktop() ? SourceOfBusiness.DESKTOP : SourceOfBusiness.MOBILE,
      taxIncludedRegion: this.isTaxIncludeRegion(taxIncludedRegion, taxExcludedRegion),
      groupId: availabilityRequest.promotionalCodeGroupId,
      customerId: availabilityRequest.travelAgencyCustomerId
    }

    if (rate.tierDiscount && availabilityRequest.tierDiscount) {
      request.tierDiscount = availabilityRequest.tierDiscount
    }

    if (rewardsNumber) {
      request.userLogin = { rewardsNumber }
    }

    return request

    function mapPromotionCode ({ searchType, promotionCode }) {
      return searchType === SearchTypes.ECERT ? promotionCode.toUpperCase() : promotionCode
    }

    function groupRates (rates) {
      const deduplicatedRates = rates.filter((rate, index) => rates.findIndex(elem => {
        return elem.beginDate === rate.beginDate && elem.endDate === rate.endDate && elem.id === rate.id
      }) === index)

      const groupedRates = deduplicatedRates.reduce((acc, val) => {
        const lasItem = acc[acc.length - 1]

        if (acc.length === 0 || val.endDate !== lasItem.endDate) {
          acc.push(val)
          return acc
        }

        lasItem.points = lasItem.points + `|${String(val.points)}`

        return acc
      }, [])

      groupedRates.forEach((rate) => {
        const rateHasNoPoints = String(rate.points).split('|').every(item => Number(item) === 0)

        rateHasNoPoints && delete rate.points
      })

      return groupedRates
    }

    function groupNights (nights) {
      return nights.reduce((flat, toFlatten) => flat.concat(Array.isArray(toFlatten) ? groupNights(toFlatten) : toFlatten), [])
    }

    function mapRates (rate, availabilityRequest) {
      const { nights } = rate
      const { checkOutDate } = availabilityRequest

      const sequencedNights = nights.reduce((acc, val, i, arr) => {
        if (!i || val.rate.identifier !== arr[i - 1].rate.identifier) {
          if (acc.length >= 1) {
            const prevNights = acc[acc.length - 1]

            prevNights.map(prevNight => {
              const { rate: { identifier } } = prevNight

              if (identifier !== val.rate.identifier) {
                prevNight.endDate = val.date
              }
            })
          }
          acc.push([])
        }
        acc[acc.length - 1].push(val)
        return acc
      }, [])

      const groupedNights = groupNights(sequencedNights)

      const rates = groupedNights
        .filter(n => n.rate)
        .map(n => {
          return {
            beginDate: DateFactory.formatDate(DateFactory.dateObject(n.date)),
            endDate: DateFactory.formatDate(DateFactory.dateObject(n.endDate || checkOutDate)),
            id: n.rate.identifier.toString(),
            points: n.pricing.pointsExtended.points
          }
        })
        .concat([])

      return groupRates(rates)
    }
  }

  async appliedBookingIgnore(preBookingId) {
    const transactionId = ExternalStorage.session.transactionId()
    const config = {
      headers: {
        transactionId,
        'Accept-Language': global.Utils.getPageLanguage()
      },
      timeout: 90000
    }
    const data = {
      preBookingId: preBookingId
    }
    return await this.httpClient.post(`${configuration.bookingIgnore}/booking-ignore`, data, config)
  }
}

export default BookingService
